<div class="d-flex align-items-center border-end border-top border-bottom shadow-sm"
     [@pulse]="light()"
     [style.borderLeft]="light().SupportsColor ? '10px solid #' + light().HexColorCode : 0">
  <div class="text-primary p-3">
    @if (light().On) {
      <fa-icon icon="toggle-on"
               size="lg"></fa-icon>
    } @else {
      <fa-icon icon="toggle-off"
               size="lg"></fa-icon>
    }
  </div>
  <h5 class="flex-grow-1 mb-0 py-2">
    {{ light().Name }} <br /><small>Zone: {{ light().Zone }}</small>
  </h5>
  <div class="mb-0 p-3">{{ light().Percentage }} %</div>
</div>